import {
  combineReducers,
} from 'redux';
import login from './login';
import dashboard from './dashboard';
import adminCompany from './admin-company';
import leaderBoard from './leader-board';
import myTopic from './my-topic';
import adminDelivery from './admin-delivery';
import adminNews from './admin-news';
import adminUsers from './admin-users';
import adminUserList from './admin-user-lists';
import dashboardTeam from './dashboard-team';
import dashboardTopic from './dashboard-topic';
import delivery from './delivery';
import detailSearch from './detail-search';
import games from './games';
import news from './news';
import playlogSearch from './playlog-search';
import players from './player';
import playersGameLogs from './player-game-logs';
import pitcherContent from './pitcher-content';
import teams from './team';
import teamReport from './team-report';
import teamPitcher from './team-pitcher';
import teamBatters from './team-batters';
import playerPitchers from './player-pitchers';
import teamSchedule from './team-schedule';
import master from './master';
import playerSearch from './player-search';
import notification from './notification';
import userTopic from './user-topic';
import metadata from './metadata';
import recommend from './recommend';


const rootReducer = combineReducers({
  login, dashboard, adminCompany, leaderBoard, myTopic,
  adminDelivery, adminNews, adminUsers,
  adminUserList, dashboardTeam, dashboardTopic, delivery, games, news,detailSearch,
  playlogSearch, players, playersGameLogs, pitcherContent, teams, teamReport,
  teamPitcher, teamBatters, playerPitchers, teamSchedule,master, playerSearch,notification,
  userTopic, metadata, recommend
});

export default rootReducer;
